
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.255 5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-3.25 1.25a3.25 3.25 0 11.892 2.237l-4.972 2.841a3.264 3.264 0 010 1.344l4.972 2.841a3.25 3.25 0 11-.864 1.81l-5.104-2.917a3.25 3.25 0 110-4.812l5.104-2.917a3.29 3.29 0 01-.028-.427zm-7.26 4.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm10.51 5.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z"}})])
          )
        }
      }
    